import { useState } from 'react';
import { Alert, Box, Button, Card, Stack, Typography } from '@mui/material';
import Iconify from '@/components/iconify/index.tsx';
import { PickemLeaderboardData } from '@/@types/api.types.ts';
import { api } from '@/api/api-client.config.ts';
import { ExportCsvButton } from '@/pages/LeaderboardPage/ExportCsvButton.tsx';
import { SendPrizeEmailButton } from '@/pages/LeaderboardPage/SendPrizeEmailButton.tsx';
import { UpdateAllLeaderboardsButton } from '@/pages/LeaderboardPage/PickemControlBar/UpdateAllLeaderboardsButton.tsx';
import { useAppSearchParams } from '@/hooks/useAppSearchParams.ts';
import { useGetPickem } from '@/api/pickems/getPickem.ts';
import { PickemTypeEnum } from '@/enums/Pickem.enums.ts';

type PickemControlBarProps = {
  leaderboardData: PickemLeaderboardData;
};

export const PickemControlBar = ({
  leaderboardData,
}: PickemControlBarProps) => {
  const { pickemId } = useAppSearchParams();

  const { data: pickem } = useGetPickem(pickemId);

  const isPrivateGame = pickem?.pickem_type === PickemTypeEnum.PRIVATE;

  const [loading, setLoading] = useState<boolean>(false);

  const handleForcePickemScoring = () => {
    setLoading(true);
    api.post(`/admin/pickems/${pickemId}/run-leaderboard-scoring`).then(() => {
      window.location.reload();
    });
  };

  if (!pickemId) return null;

  return (
    <Card style={{ padding: 20 }}>
      <Stack
        direction='row'
        alignItems='center'
        justifyContent='space-between'
        mb={5}
      >
        <Typography variant='h5' component='div' sx={{ marginBottom: 2 }}>
          Scoring
        </Typography>
        <Box>
          <SendPrizeEmailButton />

          {/* Hide button for private games */}
          {!isPrivateGame && <UpdateAllLeaderboardsButton />}

          <Button
            variant='contained'
            startIcon={<Iconify icon='eva:rewind-right-outline' />}
            onClick={() => handleForcePickemScoring()}
            sx={{ mr: 2 }}
            disabled={loading}
          >
            Score Daily
          </Button>
          <ExportCsvButton pickemId={pickemId} />
        </Box>
      </Stack>

      {leaderboardData && (
        <Alert sx={{ marginTop: 2 }} severity='info'>
          {`Pickem Scoring progress: ${leaderboardData.completedScoringCount} / ${leaderboardData.selectionsCount}`}
        </Alert>
      )}
    </Card>
  );
};
